
const CustomArrowSlide = () => {
  return {
    prevArrow: (
      <button onClick={(e) => e.stopPropagation()} className="group w-7 h-7"  style={{ left: "-11%" }}>
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 24"
          className="group-disabled:fill-gray-500 group-disabled:cursor-not-allowed group-disabled:hidden"
        >
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        </svg>
      </button>
    ),
    nextArrow: (
      <button className="group w-7 h-7">
        <svg width="24" className="group-disabled:fill-gray-500 group-disabled:cursor-not-allowed group-disabled:hidden" height="24" viewBox="0 0 24 24">
          <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path>
        </svg>
      </button>
    ),
  };
};

export default CustomArrowSlide;
